import React from 'react';

import BoosterIcon from '@/comp/common/icons/BoosterIcon';
import CompressorIcon from '@/comp/common/icons/CompressorIcon';
import DesiccantDryerIcon from '@/comp/common/icons/DesiccantDryerIcon';
import PumpIcon from '@/comp/common/icons/PumpIcon';
import RefrigeratedDryerIcon from '@/comp/common/icons/RefrigeratedDryerIcon';
import { DeviceType } from '@/constants/deviceTypeEnum';
import ProductionFloorIcon from '@/comp/common/icons/ProductionFloorIcon';

export type SccDeviceUiMeta = {
  icon: React.ReactNode;
  label: string;
};

export const DEFAULT_SCC_DEVICE_UI_META: SccDeviceUiMeta = {
  icon: <CompressorIcon />,
  label: 'Device',
};

const COMPRESSOR_UI_META: SccDeviceUiMeta = {
  icon: <CompressorIcon />,
  label: 'Comp',
};

export const SCC_DEVICE_UI_MAP: Partial<Record<DeviceType, SccDeviceUiMeta>> = {
  [DeviceType.VariableSpeedDrive]: COMPRESSOR_UI_META,
  [DeviceType.FixedSpeed]: COMPRESSOR_UI_META,
  [DeviceType.Centrifugal]: COMPRESSOR_UI_META,
  [DeviceType.VariableSpeedDriveAndPowerSensor]: COMPRESSOR_UI_META,
  [DeviceType.FixedSpeedAndPowerSensor]: COMPRESSOR_UI_META,
  [DeviceType.CentrifugalAndPowerSensor]: COMPRESSOR_UI_META,

  [DeviceType.Pump]: { icon: <PumpIcon />, label: 'Pump' },
  [DeviceType.Booster]: { icon: <BoosterIcon />, label: 'Booster' },
  [DeviceType.RefrigeratedAirDryer]: { icon: <RefrigeratedDryerIcon />, label: 'RefDryer' },
  [DeviceType.DesiccantAirDryer]: { icon: <DesiccantDryerIcon />, label: 'DesDryer' },
  [DeviceType.General]: { icon: <CompressorIcon />, label: 'General' },
  [DeviceType.ProductionFloor]: { icon: <ProductionFloorIcon />, label: 'ProductionFloor' },
};
